import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
interface PartnersPageProps {
  onNavigate: (page: string) => void;
}
export function PartnersPage({
  onNavigate
}: PartnersPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-grow w-full bg-[#f8f9fa]" data-id="element-1133">
      <PageHeader title="Agents & Partners" breadcrumb="Partners" onNavigateHome={() => onNavigate('home')} data-id="element-1134" />

      <section className="py-20" data-id="element-1135">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1136">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-1137">
            {/* Left Column */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="space-y-12" data-id="element-1138">
              <div className="space-y-6 text-brand-charcoal/80 text-lg leading-relaxed" data-id="element-1139">
                <p data-id="element-1140">
                  We understand how important your clients needs are, especially
                  when these clients are faced with mobility limitations.
                  Mobility impaired individuals often have the need to rent a
                  mobility device while on vacation. Our wheelchair and scooter
                  rental service can help make this process easy for you and
                  your client. Our scooters and wheelchair are well maintained
                  and reliable for touring popular tourist attractions. Our
                  scooters and wheelchairs are also ideal for clients going on a
                  cruise, and can be delivered directly to the cruise ship.
                </p>
                <p data-id="element-1141">
                  As our partner, you will receive professional service and we
                  guarantee to deliver the equipment at the specified time and
                  date. Becoming our partner is easy, simply call us toll-free
                  to set-up a travel agent account or complete this form to
                  start earning commissions today.
                </p>
                <p data-id="element-1142">
                  As a partner you can earn a 13% commission on all reservations
                  you book for your clients. During each reservation, please
                  provide your agent code to our representative to ensure all
                  commissions are properly credited to your account. Please
                  review our partner terms and conditions below.
                </p>
              </div>

              <div data-id="element-1143">
                <h3 className="text-2xl font-bold text-[#5c2e2e] mb-4" data-id="element-1144">
                  How do I receive my commissions?
                </h3>
                <p className="text-brand-charcoal/80 text-lg leading-relaxed font-medium" data-id="element-1145">
                  All commissions are paid during the calendar month following a
                  completed rental. Payments will be made in the form of a
                  check, payable to the name on the enrollment application.
                </p>
              </div>
            </motion.div>

            {/* Right Column */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="space-y-12" data-id="element-1146">
              {/* CTA Card */}
              <div className="bg-[#fdfbfb] border border-[#dcdcdc] rounded-2xl p-10 text-center shadow-sm" data-id="element-1147">
                <h3 className="text-2xl text-[#5c2e2e] mb-6 font-medium" data-id="element-1148">
                  Interested in earning 13%
                  <br data-id="element-1149" />
                  commision?
                </h3>
                <h2 className="text-3xl font-bold text-[#5c2e2e] mb-8" data-id="element-1150">
                  Our Booking Partners Earn
                  <br data-id="element-1151" />
                  13% Commission
                </h2>
                <button onClick={() => onNavigate('contact')} className="bg-[#4a2525] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#3a1d1d] transition-colors shadow-md cursor-pointer" data-id="element-1152">
                  Become a partner today
                </button>
              </div>

              {/* Terms */}
              <div data-id="element-1153">
                <h3 className="text-xl font-bold text-[#5c2e2e] mb-6 leading-snug" data-id="element-1154">
                  Terms and conditions for our booking partners (travel agents,
                  tour organizers, event planners etc.)
                </h3>
                <div className="space-y-6 text-brand-charcoal/80 text-base leading-relaxed font-medium" data-id="element-1155">
                  <p data-id="element-1156">
                    To ensure we credit your account properly all reservation
                    partners will be required to provide their partnership code
                    at the time of reservation.
                  </p>
                  <p data-id="element-1157">
                    Commissions are only paid for completed rentals. We do not
                    pay commissions on cancelled reservations.
                  </p>
                  <p data-id="element-1158">
                    All travel agents will be required to provide a number that
                    can be verified from a well recognized travel agency
                    organization such as the American Association of Travel
                    Agents. Failure to provide a verifiable number may result in
                    you being removed from our partner list.
                  </p>
                  <p data-id="element-1159">
                    You have the ability to earn a 13% commission for each
                    completed rental.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}